(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enervit-team"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.currentScript.closest('.enervit-team') || document.querySelector('.enervit-team');
    if (!section) return;

    var tabs = section.querySelectorAll('.enervit-team__tab');
    var panels = section.querySelectorAll('.enervit-team__panel');

    function activate(target, updateHash) {
      var panel = section.querySelector('[data-panel="' + target + '"]');
      if (!panel) return false; // neznámá kategorie → necháme aktivní výchozí tab

      tabs.forEach(function (t) {
        var on = t.dataset.tab === target;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.dataset.panel === target);
      });

      if (updateHash && window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#' + target);
      }
      return true;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.dataset.tab, true);
      });
    });

    // Otevři kategorii podle URL hashe (proklik z breadcrumbu na detailu sportovce).
    function activateFromHash() {
      var target = (window.location.hash || '').replace(/^#/, '');
      if (target) activate(target, false);
    }
    activateFromHash();
    window.addEventListener('hashchange', activateFromHash);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Ukazatel aktuální stránky (#7): při scrollu ukáže, na které stránce výsledků uživatel je.
  // Funguje pro infinite scroll (víc stránek karet v DOM) i přímé načtení ?page=N.
  (() => {
    const TEMPLATE_FALLBACK = 'Strana __N__';

    function initPageIndicator(list) {
      if (!(list instanceof HTMLElement) || list.dataset.pageIndicatorInit) return;
      const indicator = list.querySelector('.collection-page-indicator');
      if (!indicator) return;
      list.dataset.pageIndicatorInit = '1';

      const textEl = indicator.querySelector('.collection-page-indicator__text');
      const total = Number(indicator.dataset.totalPages || '1');
      const template = (textEl && textEl.getAttribute('data-page-template')) || TEMPLATE_FALLBACK;

      let ticking = false;
      const update = () => {
        ticking = false;
        const cards = list.querySelectorAll('[data-page]');
        if (!cards.length) return;

        const offset = 140; // přibližný offset headeru + ukazatele
        let current = Number(cards[0].getAttribute('data-page')) || 1;
        for (const card of cards) {
          if (card.getBoundingClientRect().top <= offset) {
            current = Number(card.getAttribute('data-page')) || current;
          } else {
            break;
          }
        }

        if (current > 1) {
          if (textEl) {
            textEl.textContent = template.replace('__N__', String(current)) + (total > 1 ? ' / ' + total : '');
          }
          indicator.classList.add('is-visible');
        } else {
          indicator.classList.remove('is-visible');
        }
      };

      const onScroll = () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      update();
    }

    const boot = () => document.querySelectorAll('results-list').forEach(initPageIndicator);
    if (document.readyState !== 'loading') boot();
    else document.addEventListener('DOMContentLoaded', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-description-image"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var TARGET = 'product-full-description';

    function scrollToDesc() {
      var el = document.getElementById(TARGET);
      if (!el) return;
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href="#' + TARGET + '"]');
      if (!link) return;
      e.preventDefault();
      scrollToDesc();
      if (history.replaceState) history.replaceState(null, '', '#' + TARGET);
    });

    function handleHash() {
      if (window.location.hash === '#' + TARGET) scrollToDesc();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', handleHash);
    } else {
      handleHash();
    }
    window.addEventListener('hashchange', handleHash);
  })();

  } catch(e) { console.error(e); }
})();
})();
